"use strict";

exports.__esModule = true;
exports["default"] = ControlIndex;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ControlIndex(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.493.063h9.188v9.188H.493zm10.912 0h9.19v9.188h-9.19zm10.912 0h9.19v9.188h-9.19zM.493 11.405h9.188v9.188H.493zm10.912 0h9.19v9.188h-9.19zm10.912 0h9.19v9.188h-9.19zM.493 22.748h9.188v9.19H.493zm10.912 0h9.19v9.19h-9.19zm10.912 0h9.19v9.19h-9.19z"
  }));
}